/* Back a Cap: kundvagnslådan med Leveransskydd. Hör ihop med sections/cart-drawer.liquid och bac-kundvagn.css.
   Concepts cart.js äger öppning, stängning och omritning (#MiniCart-<id> byts ut vid varje ändring i vagnen).
   Det här skriptet kopplar det egna: vredet som lägger till och tar bort skyddet, villkorsarket, omdömena som rullar,
   bandbilden ur studion och summan som räknar upp. Allt kopplas om varje gång temat ritat om lådan. */
(function () {
  'use strict';
  var VAGNBILD = 'bac-vagnbild-v1';   /* samma nyckel som bac-studio.js sparar under vid köpet */
  var fran = null, rullT = 0, omdomen = null;
  var skyddArbete = null;   /* lever kvar när MiniCart byts ut */

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function kr(ore) { var n = Math.round(ore / 100); return n.toLocaleString('sv-SE').replace(/ /g, ' ') + ' kr'; }
  function lasData(allt) { var s = $('script[data-bac-lada]', allt); try { return s ? JSON.parse(s.textContent) : null; } catch (x) { return null; } }
  function rutter() { var r = (window.theme && theme.routes) || {}; return { add: r.cart_add_url || '/cart/add', change: r.cart_change_url || '/cart/change', cart: r.cart_url || '/cart' }; }
  function konfig(typ) { return (window.theme && theme.utils && theme.utils.fetchConfig) ? theme.utils.fetchConfig(typ || 'javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/' + (typ || 'javascript') } }; }

  function skyddLage(lada, lage, meddelande) {
    if (!lada) return;
    if (lage) lada.setAttribute('data-bac-skydd-state', lage); else lada.removeAttribute('data-bac-skydd-state');
    var allt = $('.bac-lada__allt', lada), vred = allt && $('.bac-vred', allt);
    $$('.bac-kassa [name="checkout"], .bac-vred, [data-bac-lagg]', lada).forEach(function (el) {
      if (el === vred) return;
      el.disabled = !!lage || !!(window.BACEditCheckoutGuard && window.BACEditCheckoutGuard.blocked()); el.setAttribute('aria-disabled', el.disabled ? 'true' : 'false');
      if (lage === 'saving') el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
    });
    if (vred) {
      vred.disabled = lage === 'error' || !!(skyddArbete && skyddArbete.recovering) || !!(window.BACEditCheckoutGuard && window.BACEditCheckoutGuard.blocked());
      vred.setAttribute('aria-disabled', vred.disabled ? 'true' : 'false');
      if (lage === 'saving') vred.setAttribute('aria-busy', 'true'); else vred.removeAttribute('aria-busy');
      if (skyddArbete && skyddArbete.lada === lada && !skyddArbete.recovering) visaAvsikt(allt, skyddArbete.desired);
    }
    var text = $('[data-bac-skydd-status]', lada), igen = $('[data-bac-skydd-retry]', lada);
    if (text) { if (text.textContent !== (meddelande || '')) text.textContent = meddelande || ''; text.hidden = !meddelande; }
    if (igen) { igen.hidden = lage !== 'error'; igen.disabled = lage === 'saving'; }
  }

  function visaAvsikt(allt, pa) {
    var skydd = $('.bac-skydd', allt), vred = $('.bac-vred', allt);
    if (typeof pa !== 'boolean' || !skydd || !vred) return;
    if (pa) skydd.classList.add('pa'); else skydd.classList.remove('pa');
    vred.setAttribute('aria-checked', pa ? 'true' : 'false');
  }

  async function skyddSvar(url, options, format) {
    var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 10000);
    try {
      var response = await fetch(url, Object.assign({}, options, { signal: controller.signal }));
      if (response.ok === false) throw new Error('Butiken svarade inte');
      return await response[format || 'json']();
    } finally { clearTimeout(timer); }
  }

  var fokusVal = ['.bac-vred', '.bac-villkor', '.bac-popup__stang', '[data-bac-lagg]', '[data-bac-stang]', '.bac-popup__mer summary', '[data-bac-skydd-retry]'];
  function lasFokus(lada) {
    var allt = $('.bac-lada__allt', lada), el = document.activeElement;
    if (!allt || !el || !allt.contains || !allt.contains(el)) return null;
    for (var i = 0; i < fokusVal.length; i++) if ($(fokusVal[i], allt) === el) return { val: fokusVal[i] };
    var n = $$('a[href], button, input, summary, [tabindex]', allt).indexOf(el);
    return n < 0 ? null : { n: n, id: el.id, tag: el.tagName, href: el.getAttribute('href'), namn: el.getAttribute('name') };
  }
  function hittaFokus(allt, fokus) {
    if (!allt || !fokus) return null;
    if (fokus.val) return $(fokus.val, allt);
    var el = fokus.id && document.getElementById(fokus.id);
    if (el && allt.contains(el)) return el;
    el = $$('a[href], button, input, summary, [tabindex]', allt)[fokus.n];
    return el && el.tagName === fokus.tag && el.getAttribute('href') === fokus.href && el.getAttribute('name') === fokus.namn ? el : null;
  }
  function hallFokus(lada, pop, el) {
    /* Dessa dialogbehållare saknar tabindex: bygg om fällan utan temats title-focus. */
    if (window.theme && theme.a11y && theme.a11y.trapFocus) theme.a11y.trapFocus(pop || lada);
    if (el && !el.disabled && el.focus) el.focus({ preventScroll: true });
  }
  function lasVy(arbete) {
    var lada = arbete.lada, allt = $('.bac-lada__allt', lada), rulla = $('.bac-lada__rulla', allt), pop = $('.bac-popup', allt), ruta = pop && $('.bac-popup__ruta', pop);
    var fokus = lasFokus(lada), aktiv = document.activeElement;
    if (!fokus && (!aktiv || aktiv === document.body || aktiv === document.documentElement)) fokus = arbete.fokus;
    return { open: lada.hasAttribute('open'), fokus: fokus, rulla: rulla ? rulla.scrollTop : null, popup: !!(pop && (pop.hasAttribute('data-bac-popup-open') || pop.classList.contains('oppen'))), ruta: ruta ? ruta.scrollTop : 0, detaljer: pop ? $$('.bac-popup__mer', pop).map(function (el) { return el.open; }) : [] };
  }
  function aterstallVy(arbete) {
    var vy = arbete.vy; arbete.vy = null; if (!vy) return;
    var lada = arbete.lada, allt = $('.bac-lada__allt', lada), rulla = $('.bac-lada__rulla', allt), pop = $('.bac-popup', allt), ruta = pop && $('.bac-popup__ruta', pop);
    var oppen = vy.open && lada.hasAttribute('open') && vy.popup;
    if (pop) {
      pop.hidden = !oppen; pop.classList.toggle('oppen', oppen);
      if (oppen) pop.setAttribute('data-bac-popup-open', ''); else pop.removeAttribute('data-bac-popup-open');
      $$('.bac-popup__mer', pop).forEach(function (el, i) { el.open = !!vy.detaljer[i]; });
      $$('.bac-lada__rulla, .bac-fot', allt).forEach(function (el) { el.inert = oppen; });
    }
    function scrolla() { if (rulla && vy.rulla !== null) rulla.scrollTop = vy.rulla; if (ruta) ruta.scrollTop = vy.ruta; }
    scrolla();
    if (vy.open && lada.hasAttribute('open')) {
      var fokus = hittaFokus(allt, vy.fokus);
      if (oppen && (!fokus || !pop.contains(fokus))) fokus = $('.bac-popup__stang', pop);
      try { hallFokus(lada, oppen ? pop : null, fokus); } catch (x) { console.error(x); }
      scrolla();
    }
  }

  function ritaSkydd(vagn, arbete) {
    if (!vagn || vagn.status || vagn.errors || !Array.isArray(vagn.items) || typeof vagn.item_count !== 'number') throw new Error('Ogiltig varukorg');
    var id = 'MiniCart-' + arbete.data.sektion, html = (vagn.sections || {})[arbete.data.sektion];
    var source = typeof html === 'string' && new DOMParser().parseFromString(html, 'text/html').getElementById(id);
    var target = document.getElementById(id), data = source && lasData(source);
    var harSkydd = vagn.items.some(function (it) { return (arbete.data.skyddVariant ? String(it.variant_id) === String(arbete.data.skyddVariant) : it.key === arbete.data.skyddRad) && it.quantity > 0; });
    if (!source || !target || !data || !!data.skyddRad !== harSkydd || data.total !== vagn.total_price) throw new Error('Varukorgen kunde inte visas');
    /* Ta vyn sent: kunden kan ha öppnat eller stängt villkoren medan servern svarade. */
    arbete.vy = lasVy(arbete);
    target.innerHTML = source.innerHTML;
    koppla(arbete.lada);
    /* Vi har redan ritat denna sektion. Temats vanliga render skulle annars byta den
       igen och fokusera betyget överst. Övriga subscribers får fortfarande hela vagnen. */
    var publicerad = Object.assign({}, vagn, { sections: Object.assign({}, vagn.sections) });
    delete publicerad.sections[arbete.data.sektion];
    try { if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'bac-skydd', cart: publicerad }); } catch (x) { console.error(x); }
    return harSkydd;
  }

  async function kontrolleraSkydd(arbete) {
    var R = rutter();
    var vagn = await skyddSvar(R.cart + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
    var html = await skyddSvar(((window.theme && theme.routes && theme.routes.root_url) || '/') + '?section_id=' + encodeURIComponent(arbete.data.sektion), { cache: 'no-store' }, 'text');
    vagn.sections = {}; vagn.sections[arbete.data.sektion] = html;
    return ritaSkydd(vagn, arbete);
  }

  function skyddKlart(arbete, harSkydd) {
    if (skyddArbete !== arbete) return;
    skyddArbete = null;
    var allt = $('.bac-lada__allt', arbete.lada);
    if (allt) visaAvsikt(allt, harSkydd);
    skyddLage(arbete.lada, null, !arbete.avbruten && harSkydd === arbete.desired ? '' : 'Kontrollera ditt val av leveransskydd. Det senast sparade valet visas.');
    aterstallVy(arbete);
    if (allt) stadaForaldralos(allt, lasData(allt));
  }

  function skyddFel(arbete) {
    if (skyddArbete !== arbete) return;
    arbete.lage = 'error';
    skyddLage(arbete.lada, 'error', 'Vi kunde inte bekräfta leveransskyddet. Kontrollera varukorgen igen innan du går vidare.');
  }

  async function skyddIgen() {
    var arbete = skyddArbete; if (!arbete || arbete.lage !== 'error') return;
    arbete.lage = 'saving'; skyddLage(arbete.lada, 'saving', 'Kontrollerar varukorgen…');
    try { skyddKlart(arbete, await kontrolleraSkydd(arbete)); } catch (x) { skyddFel(arbete); }
  }

  /* Servern äger valet och alla belopp. Kassan låses tills svaret har verifierats och visats. */
  function vaxla(allt, data, vill) {
    if (window.BACEditCheckoutGuard && window.BACEditCheckoutGuard.blocked()) return;
    var vred = $('.bac-vred', allt), skydd = $('.bac-skydd', allt); if (!vred || !skydd || data.mossor === 0) return;
    if (skyddArbete) {
      if (skyddArbete.lage !== 'saving' || skyddArbete.recovering || skyddArbete.foraldralos || skyddArbete.lada !== allt.closest('cart-drawer') || vred.disabled) return;
      skyddArbete.desired = typeof vill === 'boolean' ? vill : !skyddArbete.desired;
      skyddArbete.intentSeq++; visaAvsikt(allt, skyddArbete.desired); return;
    }
    var pa = typeof vill === 'boolean' ? vill : !skydd.classList.contains('pa');
    startaSkydd(allt, data, pa, false);
  }

  async function startaSkydd(allt, data, pa, foraldralos) {
    if (skyddArbete || (foraldralos ? !data.skyddRad : !data.skyddVariant)) return;
    var lada = allt.closest('cart-drawer');
    var arbete = skyddArbete = { lada: lada, data: data, pa: pa, desired: pa, intentSeq: 0, lage: 'saving', foraldralos: foraldralos, fokus: lasFokus(lada) };
    skyddLage(arbete.lada, 'saving', 'Uppdaterar leveransskydd…');
    fran = null;
    var R = rutter();
    while (skyddArbete === arbete) {
      var sentSeq = arbete.intentSeq; arbete.pa = arbete.desired;
      var uppd = {}; uppd[arbete.data.skyddVariant] = arbete.pa ? 1 : 0;
      var body = foraldralos ? { id: arbete.data.skyddRad, quantity: 0, sections: [arbete.data.sektion] } : { updates: uppd, sections: [arbete.data.sektion] };
      try {
        var vagn = await skyddSvar(foraldralos ? R.change : R.cart + '/update.js', Object.assign({}, konfig('javascript'), { body: JSON.stringify(body) }));
        var harSkydd = ritaSkydd(vagn, arbete), nyttData = lasData($('.bac-lada__allt', lada));
        /* Bara ett direkt verifierat svar får tömma ett NYARE kundval. Ingen mellanupplåsning. */
        if (!foraldralos && nyttData && nyttData.mossor > 0 && arbete.intentSeq > sentSeq && arbete.desired !== harSkydd && !(window.BACEditCheckoutGuard && window.BACEditCheckoutGuard.blocked())) {
          arbete.data = nyttData; aterstallVy(arbete); continue;
        }
        skyddKlart(arbete, harSkydd); return;
      } catch (x) {
        /* Okänt eller avvisat utfall avbryter kön. Återhämtning läser enbart servern. */
        arbete.avbruten = arbete.intentSeq > sentSeq && arbete.desired !== arbete.pa;
        arbete.desired = arbete.pa; arbete.recovering = true;
        skyddLage(lada, 'saving', 'Kontrollerar varukorgen…');
        try { skyddKlart(arbete, await kontrolleraSkydd(arbete)); } catch (fel) { skyddFel(arbete); }
        return;
      }
    }
  }

  function stoppaOsakerKassa(e) {
    if (!skyddArbete) return;
    var target = e.target && e.target.closest ? e.target.closest('a[href], button, input, form') : null;
    var form = e.type === 'submit' ? e.target : target && target.form;
    var href = target && target.getAttribute('href'), action = form && form.getAttribute('action');
    var kassa = (target && target.name === 'checkout') || (e.submitter && e.submitter.name === 'checkout') || (form && (form.querySelector('[name="checkout"]') || Array.prototype.some.call(form.elements || [], function (control) { return control.name === 'checkout'; }))) || /\/checkouts?(?:\/|\?|$)/.test(href || action || '');
    if (!kassa) return;
    e.preventDefault(); e.stopImmediatePropagation();
    skyddLage(skyddArbete.lada, skyddArbete.lage, skyddArbete.lage === 'saving' ? 'Uppdaterar leveransskydd…' : 'Kontrollera varukorgen igen innan du går till kassan.');
  }

  /* ── summan räknar upp i stället för att byta ── */
  function rakna(el, fran, till) {
    var a = parseInt(String(fran || '').replace(/[^\d]/g, ''), 10), b = parseInt(String(till || '').replace(/[^\d]/g, ''), 10);
    if (!el || isNaN(a) || isNaN(b) || a === b) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var t0 = performance.now();
    (function steg(t) { var p = Math.min(1, (t - t0) / 320), e = 1 - Math.pow(1 - p, 3); el.textContent = kr(Math.round(a + (b - a) * e) * 100); if (p < 1) requestAnimationFrame(steg); else el.textContent = till; })(t0);
  }

  /* ── villkorsarket ── */
  function kopplaVillkor(allt, data) {
    var pop = $('.bac-popup', allt); if (!pop) return;
    var lagg = $('[data-bac-lagg]', pop), sist = $('.bac-villkor', allt);
    function bakom(p) { $$('.bac-lada__rulla, .bac-fot', allt).forEach(function (el) { el.inert = p; }); }
    function oppna(e) { if (e) { e.preventDefault(); e.stopPropagation(); sist = e.currentTarget; } pop.setAttribute('data-bac-popup-open', ''); pop.hidden = false; requestAnimationFrame(function () { if (pop.isConnected && pop.hasAttribute('data-bac-popup-open')) pop.classList.add('oppen'); }); bakom(true); setTimeout(function () { if (pop.isConnected && pop.hasAttribute('data-bac-popup-open')) hallFokus(allt.closest('cart-drawer'), pop, $('.bac-popup__stang', pop)); }, 60); }
    function stang() { if (!pop.classList.contains('oppen') && !pop.hasAttribute('data-bac-popup-open')) return; pop.removeAttribute('data-bac-popup-open'); pop.classList.remove('oppen'); bakom(false); setTimeout(function () { if (!pop.hasAttribute('data-bac-popup-open')) pop.hidden = true; }, 380); hallFokus(allt.closest('cart-drawer'), null, sist); }
    $$('.bac-villkor', allt).forEach(function (b) { b.addEventListener('click', oppna); });
    $$('.bac-popup__stang, [data-bac-stang]', pop).forEach(function (b) { b.addEventListener('click', stang); });
    pop.addEventListener('click', function (e) { if (e.target === pop) stang(); });
    if (lagg) lagg.addEventListener('click', function () { stang(); vaxla(allt, data); });
  }

  /* ── omdömena i huvudet: betyget först, sedan ett omdöme i taget, var 4,5 s ── */
  function kopplaOmdomen(allt, data, lada) {
    clearInterval(rullT); rullT = 0;
    var rull = $('.bac-rull', allt); if (!rull) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (omdomen === null) {
      omdomen = String(data.omdomen || '').split('\n').map(function (r) { var d = r.split('|'); return d.length >= 2 && d[0].trim() ? [d[0].trim(), d[1].trim()] : null; }).filter(Boolean);
    }
    if (!omdomen.length) return;
    var i = -1, paus = false, betyg = $('.bac-rad', rull) ? $('.bac-rad', rull).innerHTML : '';
    var topp = rull.parentNode; topp.addEventListener('pointerenter', function () { paus = true; }); topp.addEventListener('pointerleave', function () { paus = false; });
    rullT = setInterval(function () {
      if (paus || document.hidden || !lada.hasAttribute('open')) return;
      i = (i + 1) % (omdomen.length + 1);
      var ny = document.createElement('span'); ny.className = 'bac-rad';
      if (i === omdomen.length) ny.innerHTML = betyg;
      else { var q = document.createElement('q'); q.textContent = omdomen[i][0]; var n = document.createElement('i'); n.textContent = omdomen[i][1]; ny.appendChild(q); ny.appendChild(n); }
      var gammal = $('.bac-rad.is-in', rull); if (gammal) { gammal.classList.remove('is-in'); gammal.classList.add('is-ut'); setTimeout(function () { gammal.remove(); }, 500); }
      rull.appendChild(ny); void ny.offsetWidth; ny.classList.add('is-in');
    }, 4500);
  }

  /* ── bandet: studions egen bild av kundens mössa, sparad i webbläsaren vid köpet ── */
  function kopplaBand(allt) {
    var bilder; try { bilder = JSON.parse(localStorage.getItem(VAGNBILD) || '{}') || {}; } catch (x) { bilder = {}; }
    $$('.bac-band img[data-sig]', allt).forEach(function (img) {
      var b = bilder[img.getAttribute('data-sig')]; if (!b) return;
      var src = b.band || null; if (!src || img.getAttribute('src') === src) return;
      img.classList.add('is-band'); img.src = src;
    });
  }

  /* ── datumet i tidslinjen på svenska, oavsett vad Liquid gav ── */
  function kopplaDatum(allt) {
    var s = $('.bac-tid li.is-nu > span', allt); if (!s) return;
    try { s.textContent = 'idag, ' + new Date().toLocaleDateString('sv-SE', { day: 'numeric', month: 'long' }); } catch (x) {}
  }

  /* ── ett skydd utan mössa ska bort (mössan togs bort men tillvalet låg kvar) ── */
  function stadaForaldralos(allt, data) {
    if (!data || data.mossor !== 0 || !data.skyddRad || skyddArbete) return;
    startaSkydd(allt, data, false, true);
  }

  function koppla(lada) {
    if (skyddArbete) skyddLage(lada, skyddArbete.lage, skyddArbete.lage === 'saving' ? 'Uppdaterar leveransskydd…' : 'Kontrollera varukorgen igen innan du går till kassan.');
    var allt = $('.bac-lada__allt', lada); if (!allt || allt.hasAttribute('data-bac-kopplad')) return;
    allt.setAttribute('data-bac-kopplad', '');
    var data = lasData(allt) || {};
    var vred = $('.bac-vred', allt); if (vred) vred.addEventListener('click', function () { vaxla(allt, data); });
    kopplaVillkor(allt, data); kopplaOmdomen(allt, data, lada); kopplaBand(allt); kopplaDatum(allt);
    if (fran !== null) { var tot = $('.bac-summa .bac-total', allt); if (tot) rakna(tot, fran, tot.textContent); fran = null; }
    stadaForaldralos(allt, data);
  }

  function start() {
    var lada = $('cart-drawer.bac-lada'); if (!lada) return;
    document.addEventListener('click', stoppaOsakerKassa, true);
    document.addEventListener('submit', stoppaOsakerKassa, true);
    lada.addEventListener('click', function (e) { if (e.target.closest('[data-bac-skydd-retry]')) { e.preventDefault(); skyddIgen(); } });
    koppla(lada);
    /* temats fokusfälla efter omritning rullar annars den yttre ramen (overflow hidden) så att huvudet försvinner */
    var inner = $('.drawer__inner', lada); if (inner) inner.addEventListener('scroll', function () { if (inner.scrollTop !== 0) inner.scrollTop = 0; });
    if (window.MutationObserver) new MutationObserver(function () { koppla(lada); }).observe(lada, { childList: true, subtree: true });
    document.addEventListener('cart:updated', function () { koppla(lada); });
    /* omdömena börjar om från betyget varje gång lådan öppnas */
    lada.addEventListener('toggle', function () { if (lada.hasAttribute('open')) { var allt = $('.bac-lada__allt', lada); if (allt) { kopplaOmdomen(allt, lasData(allt) || {}, lada); kopplaBand(allt); } } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
